// Redux
import { useAppDispatch } from 'redux/store';
import { signOutAsync, clearReducer } from 'redux/auth/authThunk';
// Modules
import storage from 'modules/storage';
import { useCheckpointFilters } from './index';

const useSignOut = () => {
  const dispatch = useAppDispatch();
  const { clearAllFilters } = useCheckpointFilters();

  const signOut = async () => {
    const refreshToken = storage.getData()?.refreshToken;
    const resultAction = await dispatch(signOutAsync({ refreshToken }));

    if (signOutAsync.fulfilled.match(resultAction)) {
      dispatch(clearReducer());
    }

    clearAllFilters();
  };

  return signOut;
};

export default useSignOut;
